<div style="min-width: 300px;">
    <p>Journey Info:</p>
    <p-dropdown name="trainLine" id="trainLine" [options]="trainLines" 
                [(ngModel)]="feature.value.selectedTrainLine"
                optionLabel="name" [ngModelOptions]="{standalone: true}" 
                autoWidth="false"
                [style]="{'width':'300px', 'margin-bottom':'8px'}" 
                [showClear]="true" 
                placeholder="Select a Train Line"
                (onChange)="onTrainLineChange()">
      <ng-template let-line pTemplate="item" style="min-width: 300px;">
        <div style="display:flex; flex-direction: row; justify-content: left; align-items: center; column-gap: 20px; min-width: 300px;">
          <div>{{ line.name }}</div>
        </div>
      </ng-template>
    </p-dropdown>
    <div style="display: flex; flex-direction: column;" class="p-field p-col">
      <label for="stations">Stations</label>
      <input id="stations" type="text" [(ngModel)]="feature.value.stations" 
             (ngModelChange)="onStationsChange()"
             pInputText>
      <small id="stations-help">A comma separated list of stations to monitor.<br />Leave blank to include all stations.</small>
    </div>
  </div>